
import BlogArticleReactionIcon from '~/components/blog/Article/Reaction/Icon/index';

export default {
  name: 'BlogArticleReactionIconList',
  components: {BlogArticleReactionIcon},
  props: {
    reactions: {
      type: Array,
      required: true,
    },
    hideNull: {
      type: Boolean,
      default: true,
    },
    showCount: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onClickHandler(id) {
      this.$emit('onClick', id)
    },
  },
}
